module.exports = __webpack_public_path__ + "static/media/apparel.c8a7b4eb.jpg";